module.exports = __webpack_public_path__ + "static/furniture-listlink-banner-left-section-5fa7273385299ec7832ee5bd0097b21e.png";